import { render, staticRenderFns } from "./NotificationRuleForm.vue?vue&type=template&id=afd9fe3c&scoped=true"
import script from "./NotificationRuleForm.vue?vue&type=script&lang=js"
export * from "./NotificationRuleForm.vue?vue&type=script&lang=js"
import style0 from "./NotificationRuleForm.vue?vue&type=style&index=0&id=afd9fe3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd9fe3c",
  null
  
)

export default component.exports